module.exports = __webpack_public_path__ + "static/poly-54-df5a6e5b2fb954404c677b3e0b4698f2.png";